<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-accident`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.883 11.433l16.688-5.845a2 2 0 012.371.85l4.132 6.81 3.47-1.263a2 2 0 012.564 1.195l.032.095 4.72 15.309a2 2 0 01-1.227 2.468l-1.97.718 1.025 2.819a1 1 0 01-.597 1.282l-2.82 1.026a1 1 0 01-1.281-.598l-1.026-2.82-15.035 5.473 1.026 2.82A1 1 0 0121.476 43H42a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1v-2a1 1 0 011-1h9.08l-.85-2.338-1.97.718a2 2 0 01-2.528-1.103L5.508 25.516a2 2 0 011.066-2.62l3.455-1.26-1.452-7.956a2 2 0 011.306-2.247zm26.054 5.03l-25.926 9.436 4.668 11.071 24.798-9.026-3.54-11.481zM21.012 30.408l-1.369-3.758-4.698 1.71 1.368 3.759 4.699-1.71zm11.787-8.547l1.368 3.76-4.698 1.71-1.368-3.76 4.698-1.71zm-18.957-1.613l-1.023-5.605L26.364 9.9l2.878 4.744-15.4 5.605z"/></svg>
</template>
<script>

export default {
  name: 'IconAccident',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
